import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import Vue from "vue";
import VueBreadcrumbs from "vue-2-breadcrumbs";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router.js";
import store from "./store.js";

Vue.config.productionTip = false;
Vue.use(VueBreadcrumbs);

require("vue2-animate/dist/vue2-animate.min.css");

store.commit("hydrate");

const app = {
  swal: Swal,
  moment,
  loading: false,
  http: {
    get: (url, data, settings) => http("get", url, data, settings),
    post: (url, data, settings) => http("post", url, data, settings),
    patch: (url, data, settings) => http("patch", url, data, settings),
    delete: (url, data, settings) => http("delete", url, data, settings)
  }
};

// configure axios
const http = function(method, url, data = false, settings = {}) {
  const axios_settings = settings;
  axios_settings["method"] = method;
  axios_settings["url"] = url;
  if (data && method.toLowerCase() === "get") axios_settings["params"] = data;
  else if (data) axios_settings["data"] = data;

  const headers = {};

  // add authorization token
  if (store.getters.token)
    headers["Authorization"] = `Bearer ${store.getters.token}`;
  axios_settings["headers"] = headers;

  return new Promise((resolve, reject) => {
    if (![].includes(axios_settings.url)) {
      // show loading during requests
      store.commit("isLoading", true);
    }

    axios(axios_settings)
      .then(function(response) {
        store.commit("isLoading", false);

        if (store.getters.alert.message != null)
          setTimeout(() => store.commit("removeAlert"), 1000);
        resolve(response);
      })
      .catch(function(error) {
        if (
          axios_settings.url.includes("login") == false &&
          [401, 403].includes(error.response.status)
        )
          store.commit("logout");

        console.error("http error", error);

        store.commit("isLoading", false);

        store.commit("forceLoad", false);

        reject(error);
      });
  });
};

axios.defaults.baseURL =
  process.env.VUE_APP_SIMPLELEARN_API_BASE_URL ||
  "https://simplelearn.onrender.com/api";

Vue.mixin({
  data: function() {
    return {
      get core() {
        return app;
      }
    };
  }
});

new Vue({
  router,
  store,
  app,
  vuetify,
  render: h => h(App)
}).$mount("#app");

if (process.env.VUE_APP_ENVIROMENT !== "production") {
  Vue.config.devtools = true;
  Vue.config.silent = false;
}
